<!--  -->
<template>
  <!-- <div class=""> -->
  <Modal class="z-modal" v-model="show" width="50%" :footer-hide="true" @on-visible-change="visibleChange">
    <div class="form-box">
      <Form ref="inputformValidate" label-position="right" :model="formValidate" :label-width="90">
        <FormItem label="姓名" prop="name" :rules="ruleValidate.required">
          <Input v-model="formValidate.name" placeholder="输入中文或英文名"></Input>
        </FormItem>
        <div class="row">
          <FormItem
            class="col-lg-6 col-md-12 col-sm-12 col-12"
            label="电话"
            prop="phoneNum"
            :rules="ruleValidate.required">
            <Input v-model="formValidate.phoneNum" placeholder="输入手机号"></Input>
          </FormItem>
          <FormItem
            class="col-lg-6 col-md-12 col-sm-12 col-12"
            label="企业名称"
            prop="companyName"
            :rules="ruleValidate.required">
            <Input v-model="formValidate.companyName" placeholder="输入您所在企业名称"></Input>
          </FormItem>
        </div>
        <div class="row">
          <FormItem class="col-lg-6 col-md-12 col-sm-12 col-12" label="职务" prop="post">
            <Input v-model="formValidate.post" placeholder="输入您的职务"></Input>
          </FormItem>
          <FormItem class="col-lg-6 col-md-12 col-sm-12 col-12" label="邮箱" prop="email">
            <Input v-model="formValidate.email" placeholder="输入您的邮箱"></Input>
          </FormItem>
        </div>
        <FormItem label="联系事由" prop="reason">
          <Input
            v-model="formValidate.reason"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入您的联系事由" />
        </FormItem>
      </Form>
      <div class="btn-box">
        <Button class="btn" type="text" @click="handleSubmit" :loading="loading"> 确认提交 </Button>
      </div>
    </div>
  </Modal>
  <!-- </div> -->
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import axios from "axios";
  export default {
    name: "",
    mixins: [],
    // import引入的组件需要注入到对象中才能使用
    components: {},
    model: {
      prop: "visible",
      event: "close",
    },
    props: {
      visible: {
        type: [Boolean],
        default() {
          return false;
        },
      },
    },
    data() {
      const validateName = (rule, value, callback) => {
        let reg = new RegExp("^[A-Za-z\u4e00-\u9fa5]+$", "g");
        if (value.replace(reg, "").length !== 0) {
          return callback(new Error("请填写中文或英文名！"));
        }
        return callback();
      };
      const validatePhone = (rule, value, callback) => {
        let reg = new RegExp("^[0-9]+$", "g");
        if (value.replace(reg, "").length !== 0) {
          return callback(new Error("请填写正确的手机号！"));
        }
        return callback();
      };
      // 这里存放响应式数据
      return {
        loading: false,
        formValidate: {
          name: "",
          phoneNum: "",
          companyName: "",
          post: "",
          email: "",
          reason: "",
        },
        ruleValidate: {
          required: [{ required: true, message: "此处不能为空", trigger: "blur,change" }],
          requiredName: [
            { required: true, message: "姓名不能为空！", trigger: "blur,change" },
            {
              required: true,
              validator: validateName,
              trigger: ["blur", "change"],
            },
          ],
          requiredPhone: [
            { required: true, message: "手机号不能为空！", trigger: "blur,change" },
            {
              required: true,
              validator: validatePhone,
              trigger: ["blur", "change"],
            },
          ],
          requiredOrg: [{ required: true, message: "企业名称不能为空！", trigger: "blur,change" }],
        },
      };
    },
    // 监听属性 类似于data概念
    computed: {
      show: {
        get() {
          return this.visible;
        },
        set(value) {
          this.$emit("close", value);
        },
      },
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会激活时调用
    deactivated() {}, // 如果页面有keep-alive缓存功能，这个函数会停用时调用
    // 方法集合
    methods: {
      visibleChange(e) {
        // console.log("visibleChange", e);
        if (!e) {
          this.$refs["inputformValidate"].resetFields();
        }
      },
      handleSubmit() {
        this.$refs["inputformValidate"].validate((valid) => {
          console.log("formValidate result", valid);
          if (valid) {
            this.loading = true;
            const { formValidate } = this;
            console.log("formValidate", formValidate);
            let url = "https://mail-notify.zealcomm.cn:6789/api/v1/message/send";
            console.log(axios, url);
            axios
              .post(url, formValidate)
              .then((resp) => {
                console.log(resp);
                this.$Message.success("提交成功!");
                this.show = false;
                this.loading = false;
                this.$refs["inputformValidate"].resetFields();
              })
              .catch((error) => {
                this.loading = false;
                console.log(error);
                this.$Message.error("提交失败!");
              });
          } else {
            console.log("formValidate result", valid);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  // .z-modal {
  //   ::v-deep .ivu-modal-body {
  //     padding: 16px 90px;
  //   }
  // }
  .form-box {
    margin-top: 50px;

    .ivu-form {
      ::v-deep .ivu-form-item {
        margin-bottom: 20px;
      }
    }

    .btn-box {
      @extend .flex-center;

      .btn {
        width: 100px;
        height: 42px;
        background: $main-color;
        color: #fff;
        font-size: 13px;
        font-weight: 600;

        @extend .flex-center;

        &:hover {
          background: $minor-color;
        }

        &:focus,
        &.focus {
          outline: 0;
          box-shadow: unset;
        }
      }
    }
  }
  .ivu-modal {
    z-index: 2000;
  }
</style>
